import { render, staticRenderFns } from "./SendTargetedSurveyConfirmDialog.vue?vue&type=template&id=21a12422&"
import script from "./SendTargetedSurveyConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./SendTargetedSurveyConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports